import {registerRoute as workbox_routing_registerRoute} from '/var/jenkins_home/workspace/prod-159/node_modules/workbox-routing/registerRoute.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/var/jenkins_home/workspace/prod-159/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheableResponsePlugin as workbox_cacheable_response_CacheableResponsePlugin} from '/var/jenkins_home/workspace/prod-159/node_modules/workbox-cacheable-response/CacheableResponsePlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/var/jenkins_home/workspace/prod-159/node_modules/workbox-strategies/CacheFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/var/jenkins_home/workspace/prod-159/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/var/jenkins_home/workspace/prod-159/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/var/jenkins_home/workspace/prod-159/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/var/jenkins_home/workspace/prod-159/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "cache1751123982944"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "_payload.json",
    "revision": "2cd2bf7b2192f1fcf8a04a30b8cfc4dd"
  },
  {
    "url": "404/_payload.json",
    "revision": "8005cac82057ab7fefa4970dcd9ebff9"
  },
  {
    "url": "casino/_payload.json",
    "revision": "2cd2bf7b2192f1fcf8a04a30b8cfc4dd"
  },
  {
    "url": "casino/lazer/_payload.json",
    "revision": "2cd2bf7b2192f1fcf8a04a30b8cfc4dd"
  },
  {
    "url": "casino/Lazer/_payload.json",
    "revision": "ef001c00900cdc856823dd1f2ee553b1"
  },
  {
    "url": "casino/PG/_payload.json",
    "revision": "ef001c00900cdc856823dd1f2ee553b1"
  },
  {
    "url": "casino/popular/_payload.json",
    "revision": "ef001c00900cdc856823dd1f2ee553b1"
  },
  {
    "url": "casino/PP/_payload.json",
    "revision": "ef001c00900cdc856823dd1f2ee553b1"
  },
  {
    "url": "casino/slots/_payload.json",
    "revision": "2cd2bf7b2192f1fcf8a04a30b8cfc4dd"
  },
  {
    "url": "casino/Spirit/_payload.json",
    "revision": "ef001c00900cdc856823dd1f2ee553b1"
  },
  {
    "url": "static/builds/latest.json",
    "revision": "76109d0132d7442b9d843d7c9a188cfb"
  },
  {
    "url": "static/builds/meta/98928414-b4c8-4549-a07d-9a0c8695d1ef.json",
    "revision": null
  },
  {
    "url": "manifest.webmanifest",
    "revision": "c42e5b2fdeafb78bca62431bba9d8bb7"
  }
], {});
workbox_precaching_cleanupOutdatedCaches();



workbox_routing_registerRoute(/^https:\/\/down159\.sp-slots1\.com\/.*\.(png|ico|webp|jpg|svg)(\?.*)?$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-images", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 200, maxAgeSeconds: 5184000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/down159\.sp-slots1\.com\/.*\.(js)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-js", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 400, maxAgeSeconds: 5184000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/down159\.sp-slots1\.com\/.*\.(css)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-css", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 400, maxAgeSeconds: 5184000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/down159\.sp-slots1\.com\/.*\.(json|atlas)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-json", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 100, maxAgeSeconds: 5184000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/down159\.sp-slots1\.com\/.*\.(ttf|woff|woff2)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-font", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 100, maxAgeSeconds: 5184000 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');
workbox_routing_registerRoute(({ request }) => request.destination === "document", new workbox_strategies_StaleWhileRevalidate({ "cacheName":"html-pages", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 20, maxAgeSeconds: 5184000 })] }), 'GET');
workbox_routing_registerRoute(({ url }) =>
        url.pathname.endsWith("js") ||
        url.pathname.endsWith("wasm") ||
        url.pathname.endsWith("png"), new workbox_strategies_CacheFirst({ "cacheName":"static-resources", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 50, maxAgeSeconds: 5184000 })] }), 'GET');




